
import { defineComponent, reactive, toRefs, onMounted } from 'vue';
import { useMediaQuery } from '@/composables/mediaQuery';
import { computed } from '@vue/reactivity';

export default defineComponent({
    /*サイトマップ*/
    name: 'SiteMap',
    setup() {
        const state = reactive({
            pages: computed(() => {
                if (isSp.value) {
                    return [
                        {
                            title: '会社概要',
                            link: 'https://usen.com/company/',
                        },
                        {
                            title: 'サービス一覧',
                            link: 'https://usen.com/service/',
                        },
                        {
                            title: '社会的責任（CSR）',
                            link: 'https://usen.com/csr/social/',
                        },
                        {
                            title: 'ビジネスパートナー企業募集',
                            link: 'https://usen.com/portal/partner/',
                        },
                        {
                            title: 'お客様サポート',
                            link: 'https://support.usen.com/',
                        },
                        {
                            title: 'お問合せ一覧',
                            link: 'https://usen.com/contact/',
                        },
                        {
                            title: 'グループ会社',
                            link: 'https://usen.com/company/group.html',
                        },
                    ];
                } else {
                    return [
                        {
                            title: '会社概要',
                            link: 'https://usen.com/company/',
                        },
                        {
                            title: 'ミッション',
                            link: 'https://usen.com/company/mission.html',
                        },
                        {
                            title: '社長メッセージ',
                            link: 'https://usen.com/company/message.html',
                        },
                        {
                            title: '役員一覧',
                            link: 'https://usen.com/company/executive.html',
                        },
                        {
                            title: '事業内容',
                            link: 'https://usen.com/company/business.html',
                        },
                        {
                            title: '事業所一覧',
                            link: 'https://usen.com/company/branch/',
                        },
                        {
                            title: 'グループ会社',
                            link: 'https://usen.com/company/group.html',
                            margin: true,
                        },
                        {
                            title: 'サービス一覧',
                            link: 'https://usen.com/service/',
                            margin: true,
                        },
                        {
                            title: '社会的責任（CSR）',
                            link: 'https://usen.com/csr/social/',
                        },
                        {
                            title: 'ビジネスパートナー企業募集',
                            link: 'https://usen.com/portal/partner/',
                            margin: true,
                        },
                        {
                            title: 'お客様サポート',
                            link: 'https://support.usen.com/',
                        },
                        {
                            title: 'お問い合わせ一覧',
                            link: 'https://usen.com/contact/',
                        },
                    ];
                }
            }),
            companies: [
                {
                    title: 'USEN & U-NEXT GROUP',
                    children: [
                        {
                            title: '株式会社 U-NEXT HOLDINGS',
                            link: 'https://usen-next.co.jp/',
                        },
                    ],
                },
                {
                    title: 'グループ会社',
                    children: [
                        {
                            title: '株式会社USENテクノサービス',
                            link: 'https://www.usen-ts.co.jp/',
                        },
                        {
                            title: 'USEN少額短期保険株式会社',
                            link: 'https://usen-ssi.co.jp/',
                        },
                    ],
                },
            ],
            services: [
                // １列目
                [
                    {
                        title: 'BGM・映像',
                        link: 'https://iot.usen.com/u-music/',
                        children: [
                            {
                                title: 'USEN MUSIC Entertainment',
                                link: 'https://usen.com/service/bgm/u-music/entertainment/',
                            },
                            {
                                title: 'USEN MUSIC',
                                link: 'https://iot.usen.com/u-music/',
                            },
                            {
                                title: 'OTORAKU-音・楽-',
                                link: 'https://otoraku.jp',
                            },
                            {
                                title: 'CM録音機能つきBGM',
                                link: 'https://usen.com/portal/biz_music/ez_messe/',
                            },
                            {
                                title: '海外店舗BGM',
                                link: 'https://usen.com/portal/overseas/',
                            },
                            {
                                title: '複数店舗の配信管理',
                                link: 'https://iot.usen.com/u-music/enterprise/',
                            },
                            {
                                title: 'WEDDING MUSIC BOX',
                                link: 'https://weddmusicbox.com/',
                            },
                            {
                                title: 'オフィスBGM',
                                link: 'https://sound-design.usen.com/',
                            },
                            {
                                title: 'ホームBGM',
                                link: 'https://usen.com/portal/music/',
                            },
                            {
                                title: 'USEN サイネージ',
                                link: 'https://usen.com/service/digital-signage/',
                            },
                        ],
                    },
                    {
                        title: '通信',
                        link: 'https://usen.com/service/network/',
                        children: [
                            {
                                title: 'USEN AIR UNLIMITED',
                                link: 'https://usen.com/service/wifi/u-air-5g/',
                            },
                            {
                                title: 'USEN AIR',
                                link: 'https://usen.com/service/wifi/u-air/',
                            },
                            {
                                title: 'USEN光',
                                link: 'https://usen.com/service/wifi/uhikari/',
                            },
                            {
                                title: 'USEN Wi-Fi',
                                link: 'https://usen.com/service/wifi/u-wifi/',
                            },
                            {
                                title: 'USEN GATE 02',
                                link: 'http://www.gate02.ne.jp/',
                            },
                        ],
                    },
                    {
                        title: '電話',
                        link: 'https://iot.usen.com/u-air/u-phone/',
                        children: [
                            {
                                title: 'USEN PHONE',
                                link: 'https://iot.usen.com/u-air/u-phone/',
                            },
                        ],
                    },
                    {
                        title: '防犯カメラ',
                        link: 'https://usen.com/service/camera/',
                        children: [
                            {
                                title: 'USEN Camera',
                                link: 'https://iot.usen.com/u-eyes/',
                            },
                            {
                                title: 'NEXTクラウドビュー',
                                link: 'https://usen.com/portal/support/nextcv/',
                            },
                            {
                                title: 'キャンクラウド',
                                link: 'https://www.cansystem.co.jp/camera/',
                            },
                        ],
                    },
                    {
                        title: 'デジタルサイネージ',
                        link: 'https://usen.com/service/digital-signage/',
                        children: [],
                    },
                ],
                // ２列目
                [
                    {
                        title: 'POSレジ 他',
                        link: 'https://pos.usen.com/',
                        children: [
                            {
                                title: 'USENレジ FOOD',
                                link: 'https://pos.usen.com/uregi/',
                            },
                            {
                                title: 'USENレジ BEAUTY',
                                link: 'https://pos.usen.com/uregibeauty/',
                            },
                            {
                                title: 'USENレジ STORE',
                                link: 'https://pos.usen.com/uregistore/',
                            },
                            {
                                title: 'USENレジ HEALTHCARE',
                                link: 'https://pos.usen.com/uregihealthcare/',
                            },
                            {
                                title: 'USEN TIMECARD',
                                link: 'https://pos.usen.com/utr/',
                            },
                            {
                                title: 'USEN RESERVE BEAUTY',
                                link: 'https://pos.usen.com/ursvb/',
                            },
                        ],
                    },
                    {
                        title: 'オーダーシステム',
                        link: 'https://pos.usen.com/order-solution/',
                        children: [
                            {
                                title: 'USEN Ticket & Pay',
                                link: 'https://pos.usen.com/order-solution/ticketpay/',
                            },
                            {
                                title: 'USEN SelfOrder MOBILE',
                                link: 'https://pos.usen.com/order-solution/mobileorder/',
                            },
                            {
                                title: 'USEN Order & Pay',
                                link: 'https://pos.usen.com/order-solution/orderpay/',
                            },
                            {
                                title: 'USEN SelfOrder TAB',
                                link: 'https://pos.usen.com/order-solution/tableorder/',
                            },
                            {
                                title: 'USEN HANDY',
                                link: 'https://pos.usen.com/order-solution/handy/',
                            },
                            {
                                title: 'USEN My Menu Premium',
                                link: 'https://pos.usen.com/mymenupremium/',
                            },
                            {
                                title: 'USEN Order',
                                link: 'https://pos.usen.com/u-order/',
                            },
                            {
                                title: 'Uber Eats 連携',
                                link: 'https://pos.usen.com/order-solution/delivery/',
                            },
                        ],
                    },
                    {
                        title: 'キャッシュレス決済',
                        link: 'https://pos.usen.com/u-pay/',
                        children: [
                            {
                                title: 'USEN PAY',
                                link: 'https://usen.com/service/payment/u-pay/',
                            },
                            {
                                title: 'USEN PAY ENTRY',
                                link: 'https://usen.com/service/payment/u-pay/entry.html',
                            },
                            {
                                title: 'USEN PAY QR',
                                link: 'https://usen.com/service/payment/u-pay/qr.html',
                            },
                        ],
                    },
                    {
                        title: '配膳ロボット',
                        link: 'https://usen.com/service/robot/',
                        children: [
                            {
                                title: 'Servi',
                                link: 'https://usen.com/service/robot/servi/?utm_source=usencom&utm_medium=footer',
                            },
                            {
                                title: 'BellaBot',
                                link: 'https://usen.com/service/robot/bellabot/?utm_source=usencom&utm_medium=footer',
                            },
                            {
                                title: 'KettyBot',
                                link: 'https://usen.com/service/robot/kettybot/?utm_source=usencom&utm_medium=footer',
                            },
                            {
                                title: 'PuduBot2',
                                link: 'https://usen.com/service/robot/pudubot2/',
                            },
                        ],
                    },
                    {
                        title: '清掃ロボット',
                        link: 'https://usen.com/service/cleaningrobot/',
                        children: [],
                    },
                    {
                        title: '店舗アプリ',
                        link: 'http://www.uplink-app.com/',
                        children: [
                            {
                                title: 'アプリンク',
                                link: 'http://www.uplink-app.com/',
                            },
                        ],
                    },
                ],
                // ３列目
                [
                    {
                        title: '開業サポート',
                        link: 'https://canaeru.usen.com/',
                        children: [
                            {
                                title: 'canaeru（カナエル）',
                                link: 'https://canaeru.usen.com/',
                            },
                        ],
                    },
                    {
                        title: '保証',
                        link: 'https://usen-insurance.com/?utm_source=usencom&utm_medium=footer',
                        children: [
                            {
                                title: 'テナント家賃保証',
                                link: 'https://usen.com/service/rentguarantee/',
                            },
                            {
                                title: 'USEN Warranty',
                                link: 'https://www.usen-hosho.com/warranty/',
                            },
                        ],
                    },
                    {
                        title: '保険',
                        link: 'https://usen-insurance.com/?utm_source=usencom&utm_medium=footer',
                        children: [
                            {
                                title: 'お店のあんしん保険',
                                link: 'https://usen-insurance.com/product/insurance.html',
                            },
                            {
                                title: 'ビジネスリスクGuard',
                                link: 'https://usen-insurance.com/product/riskguard.html?utm_source=usencom&utm_medium=footer',
                            },
                        ],
                    },
                    {
                        title: 'でんき',
                        link: 'https://usen.com/portal/energy/',
                        children: [
                            {
                                title: 'USENでんき',
                                link: 'https://usen.com/portal/energy/',
                            },
                            {
                                title: 'USEN GAS',
                                link: 'https://usen.com/portal/energy/gas/tokyo/',
                            },
                        ],
                    },
                    {
                        title: 'その他の店舗運営事業',
                        link: '',
                        children: [
                            {
                                title: '開業資金・店舗売却',
                                link: 'https://usen.com/portal/funds/',
                            },
                            {
                                title: 'USEN CART',
                                link: 'https://usen.com/portal/usencart/',
                            },
                            {
                                title: 'カード側インカム',
                                link: 'https://usen.com/portal/biz_music/trance_pc/',
                            },
                            {
                                title: '分煙ブース',
                                link: 'https://usen.com/portal/support/bunen/',
                            },
                            {
                                title: '日本の山水',
                                link: 'https://usen.com/portal/yamamizu/',
                            },
                            {
                                title: 'Ucare',
                                link: 'https://www.ucare.works/',
                            },
                            {
                                title: '人材採用支援（Indeed）',
                                link: 'https://usen.com/portal/support/indeed/',
                            },
                            {
                                title: 'Stay Worker',
                                link: 'https://www.stay-worker.com/business',
                            },
                            {
                                title: 'こころの保健室',
                                link: 'https://kokoro-mental.com/',
                            },
                            {
                                title: 'どこでも☆通訳',
                                link: 'https://usen.com/portal/support/dokodemo.html',
                            },
                            {
                                title: 'USENエコノミー通訳',
                                link: 'https://usen.com/portal/support/economy.html',
                            },
                            {
                                title: 'USENおもてなしキャスト',
                                link: 'https://usen.com/portal/omotenashi_cast/',
                            },
                            {
                                title: 'USENおもてなしキャスト（防災）',
                                link: 'https://usen.com/portal/omotenashi_cast/ad/lp1/',
                            },
                            {
                                title: '人材採用支援（Indeed）',
                                link: 'https://usen.com/portal/support/indeed/',
                            },
                            {
                                title: 'フードライセンスシェアリングサービス',
                                link: 'https://usen.com/service/virtual_restaurant/?utm_source=usencom&utm_medium=footer',
                            },
                            {
                                title: 'USENモバイルインターフォン',
                                link: 'https://usen.com/service/mobile_intercom/',
                            },
                        ],
                    },
                ],
                // ４列目
                [
                    {
                        title: 'WEBメディア',
                        link: '',
                        children: [
                            {
                                title: 'USEN MUSIC GUIDE（番組情報サイト）',
                                link: 'http://music.usen.com/',
                            },
                            {
                                title: 'music.usen.com（バリアフリー）',
                                link: 'https://bf.usen.com/',
                            },
                            {
                                title: 'encore（アンコール）',
                                link: 'http://e.usen.com/',
                            },
                            {
                                title: 'USEN MUSIC GARDEN',
                                link: 'https://umgarden.jp/',
                            },
                            {
                                title: 'USENナビゲーション（Uナビ）',
                                link: 'https://usen.com/portal/music/u-navi.html',
                            },
                            {
                                title: '音空間デザインラボ',
                                link: 'https://usen.com/portal/otodesign/?utm_source=usencom&utm_medium=footer',
                            },
                            {
                                title: 'ヒトサラ',
                                link: 'http://hitosara.com/success/',
                            },
                            {
                                title: 'おいしいフォト',
                                link: 'https://oishiiphoto.com/',
                            },
                            {
                                title: 'SAVOR JAPAN',
                                link: 'https://hitosara.com/success/savorjapan/',
                            },
                            {
                                title: 'SMART USEN',
                                link: 'http://smart.usen.com/',
                            },
                            {
                                title: 'U-NEXT',
                                link: 'https://video.unext.jp/',
                            },
                        ],
                    },
                    {
                        title: '病院・クリニック向け',
                        link: '',
                        children: [
                            {
                                title: 'デンタル・コンシェルジュ',
                                link: 'https://dental.c-concierge.jp/',
                            },
                            {
                                title: 'オンライン資格確認工事',
                                link: 'https://usen.com/service/healthcare/',
                            },
                            {
                                title: '医療機関向けネットワーク構築',
                                link: 'https://usen.com/service/healthcare/network-clinic/',
                            },
                            {
                                title: '医療機関向けシステム',
                                link: 'http://www.almex.jp/mc/',
                            },
                        ],
                    },
                    {
                        title: 'ホテル向け',
                        link: '',
                        children: [
                            {
                                title: 'NADESHIKO HOTEL SHIBUYA（運営）',
                                link: 'https://nadeshiko-hotel.jp/',
                            },
                            {
                                title: 'ホテル向けシステム',
                                link: 'https://www.almex.jp/hs/',
                            },
                            {
                                title: 'レジャーホテル向けシステム',
                                link: 'http://www.almex.jp/is/',
                            },
                            {
                                title: 'パッピーホテル',
                                link: 'http://happyhotel.jp/',
                            },
                        ],
                    },
                ],
            ],
        });
        const { isSp, watchMediaQuery } = useMediaQuery();
        onMounted(async () => {
            watchMediaQuery();
        });
        return {
            ...toRefs(state),
        };
    },
});
